import { Grid, Paper, styled, Tooltip, Typography } from "@mui/material";
import { Form } from "formik";
import FormikAutocomplete from "../commons/formik/FormikAutocomplete";
import FormikDatePicker from "../commons/formik/FormikDatePicker";

export const StyledExamenesPeriodicos = {
    Form: styled(Form)(({ theme }) => ({
        display: "flex",
        padding: 20,
    })),
    Grid: styled(Grid)(({ theme }) => ({
        display: "flex",
        justifyContent: "space-evenly",
        alignItems: "start"
    })),
    Establecimiento: styled(FormikAutocomplete)(({ theme }) => ({
        marginTop: 30
    })),
    DatesContainer: styled("div")(({ theme }) => ({
        display: "flex",
        marginTop: "30px"
    })),
    DateInput: styled(FormikDatePicker)(({ theme }) => ({
        marginRight: 20,
    })),
    ButtonContainer: styled("div")(({ theme }) => ({
        marginTop: 80,
    })),
    TabsTitle: styled("div")(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
    })),
}

export const StyledDependenciaSeleccionadaLabel = {
    Container: styled("div")(({ theme, noData }) => ({
        width: "90%",
        display: "flex",
        justifyContent: noData ? "center" : "space-between",
        padding: 10,
        margin: 15,
        border: `3px solid ${theme.palette.primary.main}`,
        borderRadius: 10,
        boxShadow: "10px 10px 15px -15px",
    })),
    LeftText: styled("div")(({ theme }) => ({
        display: "flex",
        justifyContent: "space-between",
    })),
    CenterText: styled(Typography)(({ theme }) => ({
        textAlign: "center",
    })),
    RightText: styled(Typography)(({ theme }) => ({
        textAlign: "end",
    })),
}

export const StyledNotificaciones = {
    Card: styled(Paper)(({ theme }) => ({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: 10,
        padding: 5,
        paddingLeft: 10,
        paddingRight: 10,
        borderRadius: 5,
    })),
    ActionsContainer: styled("div")(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
    })),
    EmptyState: styled(Typography)(({ theme }) => ({
        textAlign: "center",
    })),
    Button: styled(Tooltip)(({ theme }) => ({
    }))
}